import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Icônes au trait — 1.5px, même grille que le reste de l'interface.
// Les émojis ont été retirés : ils imposent leur propre style et cassent
// l'homogénéité typographique de l'application.
const Icon = ({ path, className }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    {path}
  </svg>
);

const tabs = [
  {
    path: '/',
    permission: 'review',
    label: 'Accueil',
    icon: <><path d="M3.5 11.5 12 4l8.5 7.5" /><path d="M5.5 10v9.5h13V10" /></>,
  },
  {
    path: '/stats',
    permission: 'stats',
    label: 'Stats',
    icon: <><path d="M4 4v16h16" /><path d="m7.5 14.5 3.5-4 3 2.5 4.5-6" /></>,
  },
  {
    path: '/review',
    permission: 'review',
    label: 'Révision',
    icon: <><path d="M12 7c-1.6-1.6-4.2-2.1-7-1.6v12c2.8-.5 5.4 0 7 1.6 1.6-1.6 4.2-2.1 7-1.6v-12c-2.8-.5-5.4 0-7 1.6Z" /><path d="M12 7v12" /></>,
  },
  {
    path: '/ai-assistant',
    permission: 'assistant',
    label: 'Assistant',
    icon: <><path d="m12 4 1.7 4.3L18 10l-4.3 1.7L12 16l-1.7-4.3L6 10l4.3-1.7Z" /><path d="m18 15 .8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8Z" /></>,
  },
  {
    path: '/search',
    permission: 'library',
    label: 'Bibliothèque',
    icon: <><path d="M4 5h4v15H4z" /><path d="M10 5h4v15h-4z" /><path d="m16.5 6.5 3.5-.8 1 15-3.5.8z" /></>,
  },
  {
    path: '/settings',
    permission: 'settings',
    label: 'Réglages',
    icon: <><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1v.3a2 2 0 1 1-4 0v-.2a1.6 1.6 0 0 0-2.8-1.1l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1A1.6 1.6 0 0 0 3.5 15a2 2 0 1 1 0-4h.2a1.6 1.6 0 0 0 1.1-2.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1A1.6 1.6 0 0 0 11 4.5a2 2 0 1 1 4 0v.2a1.6 1.6 0 0 0 2.7 1.1l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0 1.1 2.8 2 2 0 1 1 0 4h-.2Z" /></>,
  },
];

const BottomNavigation = () => {
  const location = useLocation();
  const { isAuthenticated, can } = useAuth();

  // Ne pas afficher la navbar sur la page de login, ni hors session
  if (location.pathname === '/login' || !isAuthenticated) {
    return null;
  }

  // Un onglet inaccessible ne doit pas s'afficher du tout
  const visibleTabs = tabs.filter((tab) => can(tab.permission));

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-sand-50/95 backdrop-blur border-t border-sand-200 safe-area-bottom z-50">
      <div className="max-w-2xl mx-auto">
        <div className="flex items-stretch h-[3.75rem]">
          {visibleTabs.map((tab) => {
            const active = isActive(tab.path);

            return (
              <Link
                key={tab.path}
                to={tab.path}
                aria-current={active ? 'page' : undefined}
                className={`relative flex flex-col items-center justify-center gap-1 flex-1 transition-colors ${
                  active ? 'text-clay-600' : 'text-ink-400 hover:text-ink-700'
                }`}
              >
                {/* Repère de l'onglet actif */}
                <span
                  className={`absolute top-0 h-[2px] w-7 rounded-full transition-opacity ${
                    active ? 'bg-clay-500 opacity-100' : 'opacity-0'
                  }`}
                />
                <Icon path={tab.icon} className="w-[22px] h-[22px]" />
                <span className="text-[10px] font-medium tracking-tight leading-none">
                  {tab.label}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default BottomNavigation;
